// src/components/SimpleFormComponents/SimpleAddressFormBR.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleInput from '../../SimpleInput';
import { useSimpleFormContext } from '../../SimpleFormProvider';
import useFormElement from 'hooks/useFormElement';
import SimpleAddressZip from '../../SimpleAddressZip';
import SimpleGoogleMap from '../../SimpleGoogleMap';
import appService from 'services/appService';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleAddressFormBR = ({
  subdocumentField,
  // addressVirtualField,
  showNeighborhood = false,
  showAddressReference = false,
  showMap = false,
}) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const {
    handleAddressZipBlur,
    handleAddressBlur,
    handleAddressNumberBlur,
    handleAddressChange,
    handleAddressNumberChange,
    locked,
    fieldsWithError,
    goFocus,
    form,
    getFormZipState,
  } = useSimpleFormContext();

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------
  // Build virtual field path for addresses (e.g., 'addresses_.main', 'addresses_.delivery')
  // const virtualField = addressVirtualField ? `addresses_.${addressVirtualField}` : null;

  // Use useFormElement with virtualField support
  const zipElementProps = useFormElement('zip', subdocumentField);
  const address1ElementProps = useFormElement('address1', subdocumentField);
  const address2ElementProps = useFormElement('address2', subdocumentField);
  const numberElementProps = useFormElement('number', subdocumentField);
  const neighborhoodElementProps = useFormElement('neighborhood', subdocumentField);
  const cityElementProps = useFormElement('city', subdocumentField);
  const __cityElementProps = useFormElement('__city', subdocumentField);
  const regionElementProps = useFormElement('region', subdocumentField);
  const addressReferenceElementProps = useFormElement('addressReference', subdocumentField);


  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  const zipState = getFormZipState(zipElementProps.flattenFieldName);

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------
  // const [disabledNumber, setDisabledNumber] = useState(false);

  // ---------------------------------------------------------------------------
  // 5. EFFECTS I
  // ---------------------------------------------------------------------------
  // useEffect(() => {
  //   appService.notificationDestroy('uniqueCepNotificationKey');
  //
  //   if (zipState?.searching) return setDisabledNumber(true);
  //
  //   if (disabledNumber && !zipState?.updatingCoordinates) {
  //     if (fieldsWithError?.[zipFlattenFieldName]) {
  //       goFocus(zipFlattenFieldName, true);
  //     } else if (zipState?.zipWithMultipleAddress) {
  //       appService.notification({
  //         key: 'uniqueCepNotificationKey',
  //         flag: 'i',
  //         title: translateX('unique_cep_title'),
  //         description: translateX('unique_cep_description'),
  //         duration: 0,
  //       });
  //
  //       form.setFieldsValue({ [address1FieldId]: '' });
  //       goFocus(address1FlattenFieldName, true);
  //     } else if (zipState?.apiFailure) {
  //       // API failed, focus on address1 for manual entry
  //       goFocus(address1FlattenFieldName, true);
  //     } else {
  //       goFocus(numberFlattenFieldName, true);
  //     }
  //   }
  // }, [zipState]);

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------
  const handleAddressZipBlurWrapper = ev => {
    handleAddressZipBlur?.({
      zip: zipElementProps,
      address: address1ElementProps,
      number: numberElementProps,

      ev,
      value: ev?.target?.value ?? ev?.currentTarget?.value ?? ev ?? '',
      subdocumentField,
      fullParentFieldName: zipElementProps.fullParentFieldName,
      flattenParentFieldName: zipElementProps.flattenParentFieldName,
    });
  };

  const handleAddressNumberBlurWrapper = ev => {
    handleAddressNumberBlur?.({
      zip: zipElementProps,
      address: address1ElementProps,
      number: numberElementProps,

      ev,
      value: ev?.target?.value ?? ev?.currentTarget?.value ?? ev ?? '',
      subdocumentField,
      fullParentFieldName: zipElementProps.fullParentFieldName,
      flattenParentFieldName: zipElementProps.flattenParentFieldName,
    });
  };

  const handleAddressNumberChangeWrapper = ev => {
    handleAddressNumberChange?.({
      zip: zipElementProps,
      address: address1ElementProps,
      number: numberElementProps,

      ev,
      value: ev?.target?.value ?? ev?.currentTarget?.value ?? ev ?? '',
      subdocumentField,
      fullParentFieldName: zipElementProps.fullParentFieldName,
      flattenParentFieldName: zipElementProps.flattenParentFieldName,
    });
  };

  const handleAddressChangeWrapper = ev => {
    handleAddressChange?.({
      zip: zipElementProps,
      address: address1ElementProps,
      number: numberElementProps,
      city: cityElementProps,
      region: regionElementProps,

      ev,
      value: ev?.target?.value ?? ev?.currentTarget?.value ?? ev ?? '',
      subdocumentField,
      fullParentFieldName: zipElementProps.fullParentFieldName,
      flattenParentFieldName: zipElementProps.flattenParentFieldName,
    });
  };

  const handleAddressBlurWrapper = ev => {
    handleAddressBlur?.({
      zip: zipElementProps,
      address: address1ElementProps,
      number: numberElementProps,
      city: cityElementProps,
      region: regionElementProps,

      ev,
      value: ev?.target?.value ?? ev?.currentTarget?.value ?? ev ?? '',
      subdocumentField,
      fullParentFieldName: zipElementProps.fullParentFieldName,
      flattenParentFieldName: zipElementProps.flattenParentFieldName,
    });
  };

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 8. EFFECTS II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 9. UI
  // ---------------------------------------------------------------------------

  return (
    <>
      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={6}>
          <SimpleAddressZip
            countryCode="BR"
            name={zipElementProps.fullFieldName}
            onBlur={handleAddressZipBlurWrapper}
            loading={zipState?.searching}
          />
        </Col>

        <Col xs={24} sm={13}>
          <SimpleInput
            name={address1ElementProps.fullFieldName}
            label="address"
            disabled={!zipState?.zipWithMultipleAddress && !zipState?.apiFailure}
            required={zipState?.zipWithMultipleAddress || zipState?.apiFailure}
            onChange={handleAddressChangeWrapper}
            onBlur={handleAddressBlurWrapper}
          />
        </Col>

        <Col xs={24} sm={5}>
          <SimpleInput
            name={numberElementProps.fullFieldName}
            onChange={handleAddressNumberChangeWrapper} // Debounce GPS update
            onBlur={handleAddressNumberBlurWrapper} // Immediate GPS update on blur
            loading={zipState?.updatingCoordinates}
            // disabled={zipState?.searching}
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={showNeighborhood ? 8 : 12}>
          <SimpleInput name={address2ElementProps.fullFieldName} label="additional" />
        </Col>

        {showNeighborhood ? (
          <Col xs={24} sm={8}>
            <SimpleInput
              name={neighborhoodElementProps.fullFieldName}
              disabled={!zipState?.zipWithMultipleAddress && !zipState?.apiFailure}
            />
          </Col>
        ) : null}

        {!zipState?.apiFailure ? (
          <Col xs={24} sm={showNeighborhood ? 8 : 12}>
            <SimpleInput
              name={__cityElementProps.fullFieldName}
              label="city"
              disabled={!zipState?.apiFailure}
            />
          </Col>
        ) : (
          <Col xs={24} sm={showNeighborhood ? 8 : 12}>
            <Row gutter={ROW_GUTTER}>
              <Col xs={24} sm={18}>
                <SimpleInput name={cityElementProps.fullFieldName} label="city" />
              </Col>
              <Col xs={24} sm={6}>
                <SimpleInput name={regionElementProps.fullFieldName} label="region" maxLength={2} />
              </Col>
            </Row>
          </Col>
        )}
      </Row>

      {showAddressReference ? (
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleInput
              name={addressReferenceElementProps.fullFieldName}
              label="reference_point"
            />
          </Col>
        </Row>
      ) : null}

      {showMap ? (
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleGoogleMap subdocumentField={subdocumentField} />
          </Col>
        </Row>
      ) : null}
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleAddressFormBR;

// *******************************************************************************
// HELPERS
// *******************************************************************************
